
const InfoPanel = ({ children, className = '' }) => (
  <div className={['info', className].filter(Boolean).join(' ')}>{children}</div>
);

export default InfoPanel;
